import React, { useState } from 'react';
import { Direction, ReduxState, UserData } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { Button, CircularProgress, OutlinedInput } from '@material-ui/core';
import { Link } from 'react-router-dom';
import './logindetail.style.scss';
import { API, RoutePath } from '../../../../data';
import { patch } from '../../../../scripts/api';
import { toast } from 'react-toastify';
import { setUserData } from '../../../../redux/actions';

const LoginDetail: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.profile.loginD;
    const [username, setUsername] = useState<string | undefined>(props.userData!.username);
    const [password, setPassword] = useState<string | undefined>(undefined);
    const [isSaved, setIsSaved] = useState(false);

    function onClickHandler() {
        return new Promise((resolve) =>
            patch<UserData>(API.dashboard.profile.index, { username })
                .then((res) => {
                    toast.success(lang.success);
                    props.dispatch(setUserData(res.data));
                })
                .catch((res) => {
                    if (res.status >= 500) toast.error(props.lang.serverErr);
                    else if (res.status >= 400) toast.error(lang.error);
                    else toast.error(props.lang.unknownErr);
                })
                .finally(() => resolve(true)),
        );
    }

    return (
        <div className="kiosk-login-detail">
            <div className="items">
                <p>{lang.username}</p>
                <OutlinedInput
                    id="outlined-adornment-weight"
                    value={username}
                    dir={Direction.rtl}
                    onChange={(e) => setUsername(e.target.value)}
                    startAdornment={<i className="material-icons end">person</i>}
                    className="text"
                    autoComplete="false"
                />
            </div>
            <div className="items">
                <p>{lang.pass}</p>
                <OutlinedInput
                    disabled={true}
                    id="outlined-adornment-weight"
                    value={'********'}
                    type="password"
                    dir={Direction.rtl}
                    autoComplete="new-password"
                    onChange={(e) => setPassword(e.target.value)}
                    className="text"
                />
                <Link to={RoutePath.dashboard.profile.changePassword} className="change-password">
                    {lang.changePass}
                </Link>
            </div>
            <div className="last-line">
                <Button onClick={onClickHandler} className="save" variant="contained" color="primary" disableElevation>
                    {!isSaved ? lang.save : <CircularProgress className="spinner" />}
                </Button>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    lang: state.lang,
    userData: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(LoginDetail);
